/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// state
import { TStore } from '@store/index';
import { StateCreator } from 'zustand';

// datatable apiTokens
import { tableSchemaBase as columns } from '../apitokens.columns';

// types
import { TColumnsSchema } from '@global-types/index';

/* -------------------------------------------------------------------------- */
/*                                  Interface                                 */
/* -------------------------------------------------------------------------- */
export interface IApiTokensDatatableSlice {
	apiTokensDatatableOptions: TColumnsSchema[];
	setApiTokensDatatableOptions: (
		_apiTokensDatatableOptions: TColumnsSchema[]
	) => void;
}

/* -------------------------------------------------------------------------- */
/*                                    Slice                                   */
/* -------------------------------------------------------------------------- */

export const partializeApiTokensDatatableSlice = (
	s: any
): any => ({
	apiTokensDatatableOptions: s.apiTokensDatatableOptions,
});

const initialState = {
	apiTokensDatatableOptions: columns.filter(
		(item) => item.defaultVisible
	),
};

export const createApiTokensDatatableSlice: StateCreator<
	TStore,
	[['zustand/persist', unknown]],
	[],
	IApiTokensDatatableSlice
> = (set) => ({
	...initialState,
	setApiTokensDatatableOptions: (
		_apiTokensDatatableOptions: TColumnsSchema[]
	) =>
		set({
			apiTokensDatatableOptions:
				_apiTokensDatatableOptions,
		}),
});
